export default "__VITE_ASSET__DyNPJYdZ__"